import trashIcon from "../../assets/photo/trash.svg"
import trashIconBlack from "../../assets/photo/light_theme/trash.svg"
import backIcon from "../../assets/photo/back.svg"
import backLight from "../../assets/photo/back_dark.svg"
import phyalbumIcon from "../../assets/photo/physical-album.svg"
import phyalbumGoldIcon from "../../assets/photo/gold-physical-album.svg"
import phyalbumIconBlack from "../../assets/photo/light_theme/physical_album.svg"
import downloadIcon from "../../assets/photo/download.svg"
import downloadIconBlack from "../../assets/photo/light_theme/download.svg"
import shareIcon from "../../assets/photo/share.svg"
import shareIconBlack from "../../assets/photo/light_theme/share.svg"
import menuIcon from "../../assets/navbar/phone_menu.svg"
import menuIconBlack from "../../assets/navbar/phone_menu_black.svg"
import moveIcon from "../../assets/photo/move.svg"
import moveIconBlack from "../../assets/photo/light_theme/move.svg"
import playIcon from "../../assets/photo/Play Button.svg"
import playIconBlack from "../../assets/black/Play Button.svg"
import pauseIcon from "../../assets/photo/Pause Button.svg"
import pauseIconBlack from "../../assets/black/Pause Button.svg"
import { MyDispatch, MySelector } from "../../redux/store"
import { useDispatch } from "react-redux"
import { HandleAsyncFns } from "../../hooks/handleAsyncFns"
import { useNavigate } from "react-router-dom"
import {
  setDeleteArray,
  setFullScreen,
  setFullScreenObject,
  setMoveFolderArray,
} from "../../redux/utilSlice"
import { checkInPhysicalAlbum } from "../../utils/checkInPhysicalAlbum"
import { getFilesInAnyAlbum } from "../../utils/getFilesInAnyAlbum"
import Dropdown from "../gallery/Dropdown"
import { Tooltip } from "@mui/material"
import { getOptimalUrls } from "../../utils/getOptimalUrl"

interface FullScreenNavProps {
  isSlideshow?: boolean
  onToggleSlideshow?: () => void
}

const FullScreenNav = ({ isSlideshow, onToggleSlideshow }: FullScreenNavProps) => {
  const navigate = useNavigate()
  const dispatch = useDispatch<MyDispatch>()
  const { category, eventId } = MySelector((state) => state.event)
  const {
    type,
    fullScreen,
    fullScreenObject,
    activeAlbumId,
    downloadData: { downloadEnabled },
  } = MySelector((state) => state.util)

  const { albumMemberships } = MySelector((state) => state.gallery)
  const { theme } = MySelector((state) => state.theme)

  const filesInAnyAlbum = getFilesInAnyAlbum(albumMemberships)

  const { downloadFile, moveToPhysicalAlbum, shareFile } = HandleAsyncFns()

  const phoneMenuOptions = [
    ...(downloadEnabled && fullScreenObject
      ? [
          {
            title: "Download",
            fn: () => {
              const { url: optimalUrl, compressedUrl: optimalCompressedUrl } = getOptimalUrls(fullScreenObject)
              downloadFile?.([
                {
                  url: optimalUrl,
                  name: fullScreenObject.name,
                  compressedUrl: optimalCompressedUrl,
                  b2Url: fullScreenObject.b2Url,
                  b2CompressedUrl: fullScreenObject.b2CompressedUrl,
                  id: fullScreenObject.id,
                },
              ])
            },
          },
        ]
      : []),
    ...(onToggleSlideshow
      ? [
          {
            title: isSlideshow ? "Stop slideshow" : "Start slideshow",
            fn: onToggleSlideshow,
          },
        ]
      : []),
    ...(category === "host"
      ? [
          {
            title: "Delete",
            fn: () => dispatch(setDeleteArray?.([fullScreenObject?.id])),
          },
          {
            title: "Share",
            fn: () => shareFile.setSharable(fullScreenObject?.id || ""),
          },
        ]
      : [])
  ]

  const handleBack = () => {
    dispatch(setFullScreen(false))
    dispatch(setFullScreenObject(null))
    type === "gallery"
      ? navigate(`/${eventId}/gallery`)
      : navigate(
          activeAlbumId
            ? `/${eventId}/physical-album/${activeAlbumId}`
            : `/${eventId}/physical-album`
        )
  }

  return (
    <div
      className={`bg-white/85 dark:bg-black/85  justify-between items-center z-[5050] p-4 ${
        fullScreen && fullScreenObject ? "flex" : "hidden"
      }`}
    >
      <img
        src={theme === "dark" ? backIcon : backLight}
        alt=""
        className="h-6 w-6 cursor-pointer shrink-0"
        onClick={handleBack}
      />
      <p className="text-brightBlack dark:text-offWhite text-sm font-medium truncate mx-4 max-w-[40%] lg:max-w-[60%]">
        {fullScreenObject?.name ?? ""}
      </p>
      {type === "gallery" && (
        <div className="flex justify-center items-center gap-4 lg:gap-7">
          {category === "host" && (
            <Tooltip title="Move to Folder" arrow>
              <img
                src={theme === "dark" ? moveIcon : moveIconBlack}
                alt=""
                onClick={() =>
                  dispatch(setMoveFolderArray?.([fullScreenObject?.id || ""]))
                }
                className={`h-6 w-6 cursor-pointer`}
              />
            </Tooltip>
          )}
          {category === "host" && (
            <Tooltip title="Add to Physical Album" arrow>
              <img
                src={
                  checkInPhysicalAlbum(
                    fullScreenObject?.id || "",
                    filesInAnyAlbum
                  )
                    ? phyalbumGoldIcon
                    : theme === "dark"
                    ? phyalbumIcon
                    : phyalbumIconBlack
                }
                alt=""
                onClick={() =>
                  moveToPhysicalAlbum?.([fullScreenObject?.id || ""])
                }
                className={`h-6 w-6 cursor-pointer`}
              />
            </Tooltip>
          )}
          {category === "host" && (
            <Tooltip title="Delete" arrow>
              <img
                src={theme === "dark" ? trashIcon : trashIconBlack}
                alt=""
                className="h-[21px] w-[21px] cursor-pointer hidden lg:block"
                onClick={() =>
                  dispatch(setDeleteArray?.([fullScreenObject?.id]))
                }
              />
            </Tooltip>
          )}
          {downloadEnabled && (
            <Tooltip arrow title="Download">
              <img
                src={theme === "dark" ? downloadIcon : downloadIconBlack}
                alt=""
                onClick={() => {
                  if (fullScreenObject) {
                    const { url: optimalUrl, compressedUrl: optimalCompressedUrl } = getOptimalUrls(fullScreenObject)
                    downloadFile?.([
                      {
                        url: optimalUrl,
                        name: fullScreenObject.name,
                        compressedUrl: optimalCompressedUrl,
                        b2Url: fullScreenObject.b2Url,
                        b2CompressedUrl: fullScreenObject.b2CompressedUrl,
                        id: fullScreenObject.id,
                      },
                    ])
                  }
                }
                }
                className="h-[26px] w-[26px] cursor-pointer hidden lg:block"
              />
            </Tooltip>
          )}
          {category === "host" && (
            <Tooltip title="Share" arrow>
              <img
                src={theme === "dark" ? shareIcon : shareIconBlack}
                alt=""
                onClick={() =>
                  shareFile.setSharable(fullScreenObject?.id || "")
                }
                className="h-[20px] w-[20px] cursor-pointer hidden lg:block"
              />
            </Tooltip>
          )}

          {/* Slideshow button */}
          {onToggleSlideshow && (
            <Tooltip title={isSlideshow ? "Stop slideshow" : "Start slideshow"} arrow>
              <img
                src={
                  isSlideshow
                    ? theme === "dark" ? pauseIcon : pauseIconBlack
                    : theme === "dark" ? playIcon : playIconBlack
                }
                alt=""
                onClick={onToggleSlideshow}
                className="h-[26px] w-[26px] cursor-pointer hidden lg:block"
              />
            </Tooltip>
          )}

          {(category === "host" || onToggleSlideshow) && (
            <Dropdown
              trigger={
                <img
                  src={theme === "dark" ? menuIcon : menuIconBlack}
                  alt=""
                  className="h-[18px] w-[18px] cursor-pointer lg:hidden"
                />
              }
              width="110px"
              zIndex={5000}
            >
              {phoneMenuOptions?.map((po) => (
                <p
                  key={po.title}
                  className="text-newDarkBlack dark:text-white p-3 text-sm"
                  onClick={po.fn}
                >
                  {po.title}
                </p>
              ))}
            </Dropdown>
          )}
        </div>
      )}
      {type === "physical" && (
        <Tooltip arrow title="Remove from Physical Album">
          <img
            src={theme === "dark" ? trashIcon : trashIconBlack}
            alt=""
            className="h-[21px] w-[21px] cursor-pointer"
            onClick={() => dispatch(setDeleteArray?.([fullScreenObject?.id]))}
          />
        </Tooltip>
      )}
    </div>
  )
}

export default FullScreenNav
